function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) =>
/*#__PURE__*/
React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props),
/*#__PURE__*/
React.createElement("path", {
  d: "M474 453H40c-18 0-32-14-32-31V142c0-18 15-31 32-31h97l39-48c7-9 12-14 29-14h104c16 0 23 7 30 14l38 48h97c18 0 32 14 32 31v280c0 18-15 31-32 31zM257 169c-58 0-107 48-107 107 0 58 49 106 107 106 59 0 107-48 107-106 0-59-48-107-107-107z"
})));